import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
export function Button({
  children,
  href,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-block bg-forest hover:bg-forest-dark text-white font-semibold text-base py-3 px-6 rounded-lg transition-colors duration-300 text-center shadow-md';
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={`${baseStyles} ${className}`} data-id="element-14">
        {children}
      </a>;
  }
  return <button className={`${baseStyles} ${className}`} {...props} data-id="element-15">
      {children}
    </button>;
}